module.exports = __webpack_public_path__ + "static/media/BCS-2Views_3.eec0af1d.png";